import {post, get} from '@/utils/request'

// 查询订单明细列表
export function getOrderListAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/bisinessOrderList'
    })
}

// 查询佣金总和和记录总数
export function getSumCountAndCommissionAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getSumCountAndCommission'
    })
}

// 查询订单明细列表导出
export function orderExportAPI(data) {
    return get({
        data,
        url: 'commission/business-order-record/bisinessOrderListExport'
    })
}

// 详情-获取订单信息
export function getOrderInfoAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getOrderInfo'
    })
}

// 详情-获取支付信息
export function getPayInfoAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getPayInfo'
    })
}

// 详情-获取分账信息
export function getSubAccountInfoAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getSubAccountInfo'
    })
}

// 详情-获取资金流水信息
export function getMoneyFlowInfoAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getMoneyWater'
    })
}

// 详情-获取稽核冲账信息
export function getAuditAccountLogAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getAuditAccountLog'
    })
}

// 详情-稽核冲账之前需要查询钱包余额
export function getWalletBalanceAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/getWalletBalance'
    })
}

// 详情-稽核冲账
export function auditAccountAPI(data) {
    return post({
        data,
        url: 'commission/business-order-record/auditAccount'
    })
}